"use client"
import type { CurrencyPreference } from "@opensea/navigation"
import { ToggleButtonGroup, ToggleButtonGroupItem } from "@opensea/ui-kit"
import { useTranslations } from "next-intl"
import { useCurrencySwitch } from "@/hooks/use-currency-switch"
import { Sound, usePlaySound } from "@/hooks/use-play-sound"

export function PageFooterCurrencyToggle() {
  const { currency, setCurrency } = useCurrencySwitch()
  const [playSelect] = usePlaySound(Sound.Select)
  const t = useTranslations("PageFooterCurrencyToggle")

  return (
    <ToggleButtonGroup
      onValueChange={value => {
        setCurrency(value as CurrencyPreference)
        playSelect()
      }}
      size="sm"
      value={currency}
    >
      <ToggleButtonGroupItem value="crypto">
        {t("crypto")}
      </ToggleButtonGroupItem>
      <ToggleButtonGroupItem value="usd">{t("usd")}</ToggleButtonGroupItem>
    </ToggleButtonGroup>
  )
}
